Vue.component('homepage-slider', {
    props: ['slides'],

    data() {
        return {
            // Third-party
            hammertime: null,

            currentIndex: 0,
            imageTransition: 'transition-homepage-image-right',
        };
    },

    watch: {
        nextSlide(newSlide, oldSlide) {
            if (newSlide) {
                EventBus.$emit('next-slide-set');
            }
            Vue.nextTick(() => {
                if (objectFitPolyfill !== undefined) {
                    objectFitPolyfill();
                }
            });
        },
    },

    computed: {
        prevIndex() {
            // `this` points to the vm instance
            return (this.currentIndex === 0) ? this.slides.length - 1 : (this.currentIndex - 1);
        },
        nextIndex() {
            // `this` points to the vm instance
            return (this.currentIndex === (this.slides.length - 1)) ? 0 : (this.currentIndex + 1);
        },
    },

    created() {
        document.documentElement.classList.add('full-screen');
    },

    mounted() {
        // Lister for user scroll down, which fires the 'user-scroll-down' Event
        this.$root.listenForScroll();

        EventBus.$once('user-scroll-down', () => {
            this.$root.removeScrollListener();
            this.transitionToStory();
        });

        document.addEventListener('keyup', this.keyEvents);

        this.initHammerTime();
    },

    methods: {
        transitionToStory() {
            if (this.$root.showIntroduction) {
                return;
            }

            this.$root.router.transition = 'homepage-slider-to-work';

            page(this.slides[this.currentIndex].url);
        },

        /**
         * Handles previous mouse-enter event.
         *
         * @returns {Void}
         */
        onSliderPreviousMouseEnter() {
            if (Modernizr.touchevents) {
                return;
            }

            if (!this.previousTl) {
                this.previousTl = new TimelineMax({ paused: true });

                this.previousTl.fromTo('#slider-previous .circle', 0.4, { scale: '1', ease: Power1.easeInOut }, { scale: '1.4', ease: Power1.easeInOut }, 0);
                this.previousTl.fromTo('#slider-previous .arrow-left', 0.5, { x: '0%', width: '75px', ease: Power1.easeInOut }, { x: '-170%', width: '42px', ease: Power1.easeInOut }, 0);
                this.previousTl.fromTo('#slider-previous .name', 0.8, { autoAlpha: '0', ease: Power1.easeInOut }, { autoAlpha: '1', ease: Power1.easeInOut }, 0);
            }

            this.previousTl.play(0).timeScale(1);
        },

        /**
         * Handles previous mouse-leave event.
         *
         * @returns {Void}
         */
        onSliderPreviousMouseLeave() {
            if (!this.previousTl || Modernizr.touchevents) {
                return;
            }

            this.previousTl.reverse().timeScale(1.3);
        },

        /**
         * Handles next mouse-enter event.
         *
         * @returns {Void}
         */
        onSliderNextMouseEnter() {
            if (Modernizr.touchevents) {
                return;
            }

            if (!this.nextTl) {
                this.nextTl = new TimelineMax({ paused: true });

                this.nextTl.fromTo('#slider-next .circle', 0.4, { scale: '1', ease: Power1.easeInOut }, { scale: '1.4', ease: Power1.easeInOut }, 0);
                this.nextTl.fromTo('#slider-next .arrow-right', 0.5, { x: '0%', width: '75px', ease: Power1.easeInOut }, { x: '170%', width: '42px', ease: Power1.easeInOut }, 0);
                this.nextTl.fromTo('#slider-next .name', 0.8, { autoAlpha: '0', ease: Power1.easeInOut }, { autoAlpha: '1', ease: Power1.easeInOut }, 0);
            }

            this.nextTl.play(0).timeScale(1);
        },

        /**
         * Handles next mouse-leave event.
         *
         * @returns {Void}
         */
        onSliderNextMouseLeave() {
            if (!this.nextTl || Modernizr.touchevents) {
                return;
            }

            this.nextTl.reverse().timeScale(1.3);
        },

        next() {
            if (this.inTransition) {
                return;
            }

            this.imageTransition = 'transition-homepage-image-right';
            this.inTransition = true;
            const nextIndex = this.currentIndex + 1;

            if (nextIndex > this.slides.length - 1) {
                this.currentIndex = 0;
                return;
            }

            this.currentIndex = nextIndex;
        },

        previous() {
            if (this.inTransition) {
                return;
            }

            this.imageTransition = 'transition-homepage-image-left';
            this.inTransition = true;

            const previousIndex = this.currentIndex - 1;

            if (previousIndex < 0) {
                this.currentIndex = this.slides.length - 1;
                return;
            }

            this.currentIndex = previousIndex;
        },

        afterEnter(el) {
            this.inTransition = false;

            Vue.nextTick(() => {
                TweenMax.to('.slide .image-holder', 30, { delay: 0.5, scale: 1.4, ease: ExpoScaleEase.config(1, 1.4) });
            })
        },

        enter(el) {
            // Vue.nextTick(() => {
            //     if (objectFitPolyfill !== undefined) {
            //         objectFitPolyfill();
            //     }
            // });
        },

        /**
         * Initialize Hammertime
         *
         * @return {void}
         */
        initHammerTime() {
            this.hammertime = new Hammer(this.$el, {});
            this.hammertime.get('swipe').set({ direction: Hammer.DIRECTION_ALL });

            this.hammertime.on('swipeleft', (ev) => {
                this.next();
            });

            this.hammertime.on('swiperight', (ev) => {
                this.previous();
            });

            this.hammertime.on('swipeup', (ev) => {
                this.transitionToStory();
            });
        },

        /**
	     * Initialize keyevents on the document
	     *
	     * @return {void}
	     */
        keyEvents(e) {
            switch (e.keyCode) {
                case 37:
                    this.previous();
                    break;
                case 39:
                    this.next();
                    break;
                case 40:
                    this.transitionToStory();
                    break;
                default:
                    break;
            }
        },

    },

    beforeDestroy() {
        document.removeEventListener('keyup', this.keyEvents);
        this.$root.removeScrollListener();

        EventBus.$off('user-scroll-down');
        EventBus.$off('user-scroll-up');

        this.hammertime.off('swipeleft');
        this.hammertime.off('swiperight');
        this.hammertime.off('swipeup');
        this.hammertime.destroy();
        this.hammertime = null;
    },
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/homepage-slider.js